export default{
    accountOrPasswordError: "账号或密码错误",
    noAuth:"暂时无权限，请联系客服人员！"
}